import {styled} from "@mui/material";

export const CenteredCircularProgressContainer =  styled('div')`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`